import React from 'react';
import { Shield, FileCheck, Users, Clock } from 'lucide-react';
import { legalSecurityData } from '../mock';

const LegalSecurity = () => {
  const icons = [Shield, FileCheck, Users, Clock];

  return (
    <section className="py-24 bg-gradient-to-r from-gray-100 to-green-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-2xl mb-6">
            <Shield className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {legalSecurityData.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            {legalSecurityData.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {legalSecurityData.features.map((feature, index) => {
            const IconComponent = icons[index];
            
            return (
              <div 
                key={feature}
                className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl border border-gray-200 hover:border-green-300 transform hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-green-600 transition-colors duration-300">
                  <IconComponent className="w-6 h-6 text-green-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <p className="text-gray-700 font-medium leading-relaxed">
                  {feature}
                </p>
              </div>
            );
          })}
        </div>

        {/* Additional Trust Elements */}
        <div className="mt-16">
          <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-200">
            <div className="grid lg:grid-cols-3 gap-8 items-center">
              <div className="lg:col-span-2">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Tu tranquilidad es nuestra prioridad
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Trabajamos con un modelo de negocio transparente y ético. No cobramos nada hasta que no hay un acuerdo exitoso entre las partes. 
                  Nuestros contratos están supervisados por un equipo legal especializado en derecho inmobiliario.
                </p>
                <div className="flex items-center gap-6 text-sm">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    <span className="text-gray-600">Proceso 100% legal</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    <span className="text-gray-600">Sin letra pequeña</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    <span className="text-gray-600">Máxima transparencia</span>
                  </div>
                </div>
              </div>
              
              <div className="text-center lg:text-right">
                <div className="bg-green-50 rounded-2xl p-6 border-2 border-green-200">
                  <div className="text-3xl font-bold text-green-600 mb-2">0€</div>
                  <div className="text-gray-700 font-semibold mb-1">Coste inicial</div>
                  <div className="text-gray-500 text-sm">Solo cobramos por éxito</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalSecurity;